import React from 'react'

import * as S from './DataItemValue.styled'

type DataItemValueProps = {
  value: string | number
  subValue?: string | number
}

export const DataItemValue = ({ value, subValue }: DataItemValueProps) => {
  return (
    <S.Container>
      {value}
      {subValue && <S.SubValue>{subValue}</S.SubValue>}
    </S.Container>
  )
}
